/* unplugin-vue-components disabled */import script from "./StageRolesManager.vue?vue&type=script&setup=true&lang=js"
export * from "./StageRolesManager.vue?vue&type=script&setup=true&lang=js"

import "./StageRolesManager.vue?vue&type=style&index=0&id=195ff95b&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-195ff95b"]])

export default __exports__